/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { SellerShop } from '@gql/SellerShop'

export type SellerDoc = NN<gen.SellerShopQuery['publicSeller']>
export type SellerSelect = 'b2b' | 'retail' | 'auto'

export const RETAIL_SELLER_ID = '630f4c397faeb45f5a90b893'
export const B2B_SELLER_ID = '690e04cd353df35ec6c47cfd'

function isThisSeller(doc: SellerDoc | None, id: string | None): doc is SellerDoc {
  return !!id && !!doc?.doc && helpers.isIn(id, doc?.doc?._id, doc?.doc?.handle)
}

function toThisSeller(doc: SellerDoc | None, id: string | None): SellerDoc | undefined {
  return isThisSeller(doc, id) ? doc : undefined
}

export function useIsB2B() {
  return useParams((_, i) => myLinkName(i)?.startsWith('b2b'))
}

export function useSellerId(sellerSelect: SellerSelect) {
  const isB2b = useIsB2B()
  if (sellerSelect === 'b2b') return toRef(B2B_SELLER_ID)
  if (sellerSelect === 'retail') return toRef(RETAIL_SELLER_ID)
  return computed(() => (isB2b.value ? B2B_SELLER_ID : RETAIL_SELLER_ID))
}

function useSellerStateGlobal() {
  return useState<SellerDoc | undefined>('app:seller', () => shallowRef<SellerDoc>({ productCount: 0, doc: undefined, _id: '', v1: '' }))
}
function useSellerStateLocal() {
  return shallowRef<SellerDoc | undefined>({ productCount: 0, doc: undefined, _id: '', v1: '' })
}

export function useSeller(fetch: 'server' | 'browser', sellerSelect?: SellerSelect) {
  const holder = sellerSelect ? useSellerStateLocal() : useSellerStateGlobal()
  const sellerId = useSellerId(sellerSelect || 'auto')
  // const sellerId = computed(() => sellerIdDefault || sellerIdFromPage.value)

  const skip = shallowRef(fetch !== 'server')
  onNuxtReady(() => (skip.value = false))

  useApolloWrap2<gen.SellerShopQuery, gen.SellerShopQueryVariables>(SellerShop)({
    vars() {
      if (skip.value) return
      const handle = sellerId.value
      return handle ? { handle } : undefined
    },
    ui: (i) => i?.publicSeller,
    on({ ui }) {
      const id = sellerId.value
      if (ui?.doc && isThisSeller(ui, id)) holder.value = ui
      else if (!id) holder.value = undefined
    },
  })

  return {
    sellerId,
    seller: computed(() => (skip.value ? undefined : toThisSeller(holder.value, sellerId.value))),
    isDefault: computed(() => sellerId.value === RETAIL_SELLER_ID),
    handle: toRef(() => holder.value),
  }
}
